const $ = window.jQuery;
const $window = window.$window || $(window);

const ConditionalFields = {
  init() {
    var $conditionalContainers = $('[data-conditional="true"]');
    if (!$conditionalContainers.length) return;

    $conditionalContainers.each((index, div) => {
      this.each(div);
    });
  },

  each(div) {
    let $container = $(div);

    const conditionalName = $container.data("conditional-name");
    const conditionalValue = $container.data("conditional-value");
    const input = $('input[name="' + conditionalName + '"');
    const initialVal = this.getValue(conditionalName);
    if (initialVal === conditionalValue) {
      $container.show();
    } else {
      $container.hide();
    }

    // Add event listener to
    $(input).change(function checkConditionalField(event) {
      const inputVal = event.target.value;
      if (inputVal === conditionalValue) {
        $container.show();
      } else {
        $container.hide();
      }
    });

    // do something here
    //alert('Example 1 is working...');
  },

  getValue(name) {
    const input = $('input[name="' + name + '"');
    return input.length > 1
      ? $(input)
          .filter(":checked")
          .val()
      : $(input).val();
  },
};

export default ConditionalFields;
